module.exports = __webpack_public_path__ + "static/media/anc8ru.aafb052e.pdf";